import React from "react";
import { CommonIconButton } from "./common-styled";
import { AiOutlineUndo } from "react-icons/ai";
import styled from "styled-components";
import { useSetAtom } from "jotai";
import { endStateAtom } from "../jotai/game";

const RetryButton = () => {
  const setEndState = useSetAtom(endStateAtom);

  return (
    <CommonIconButton
      onClick={() => {
        setEndState(false);
      }}
    >
      <RetryIcon />
    </CommonIconButton>
  );
};

export default RetryButton;

const RetryIcon = styled(AiOutlineUndo)`
  font-size: 35px;
`;
